{
  "name": "quality-assurance",
  "hostname": "qa.serveport.com",
  "development": true,
  "production": false,
  "applicationName": "ServePort",
  "sourceVersion": "51ecffabfac73e2a61ed9d99bb7cb674aa0abd64",
  "errors": {
    "numRetries": 3
  },
  "urls": {
    "apiRootCoManage": "https://@.qa.serveport.com/_api/comanage/",
    "apiRootLpms": "https://@.qa.serveport.com/_api/lpms/",
    "apiRootSquirrel": "https://@.qa.serveport.com/_api/squirrel/",
    "apiRootRms": "https://@.qa.serveport.com/_api/rms/"
  },
  "stripe": {
    "key": "pk_test_sXNkfHf4SoQCOwMv6G26jnOd00AaAlGrWM"
  },
  "auth0": {
    "authorityRoot": "safarilaw-qa.auth0.com",
    "clientId": "BKDju9RPeR0vRALU2mkwOMOCAgI4ceXl",
    "useLocalStorageCache": false
  },
  "auth": {
    "inactivityTimeout": 0,
    "inactivityWarning": 0
  },
  "statusApp": {
    "apiRootUrl": "https://@.qa.serveport.com/_api/maintenance/",
    "code": "o33J6l83lG-HUvterNqfuIAfeJcqvqnNN2s-bvpGqEtvAzFuTio3nQ==",
    "cacheDurationInMinutes": 5
  },
  "featureFlags": {
    "demoPreviews": true,
    "devTools": true,
    "devExceptions": true
  },
  "loggers": {
    "elmah": {
      "apiKey": "752d3d5a800541cd8dd1b5d747cc188a",
      "logId": "6045357b-2709-490a-be56-96229bca203a"
    },
    "appInsights": {
      "instrumentationKey": "63b5b902-5193-4a8a-b14e-db55e9eee613"
    }
  },
  "uiSettings": {
    "hasNavbar": true,
    "list": {
      "maxCountInMemory": 10000,
      "pageSize": 20
    },
    "maxSubtypesToShowInDropdown": 0,
    "updatePollFrequency": 3600,
    "showSwWarning": true,
    "richTextEditor": {
      "initializationTimeoutInMs": 2000
    },
    "file": {
      "previewDialogTimeLimitInSeconds": 5,
      "downloadTarget": "_self",
      "tusUploadLimitInMb": 0,
      "maxCorrespondenceSizeAttachmentInMb": 25
    },
    "reports": {
      "key": "Z7EC-XGIC55-0N4F3F-1V0I54-5H0S6L-2A2S08-3C0O26-4D5X6H-41036E-4M3C3L"
    }
  },
  "signalR": {
    "hubs": [
      {
        "api": "rms",
        "name": "submissions",
        "url": "signalr/submissions"
      }
    ]
  }
}
